import { Cargando } from '../../componentes/Cargando'
import { EstadoError } from '../../componentes/EstadoError'
import { CabeceraModal, Insignia } from '../../componentes/formulario'
import { Modal } from '../../componentes/Modal'
import { useEditarCliente } from '../../hooks/useGestionClientes'
import { useEsAdmin } from '../../hooks/useUsuarioActual'
import { useClienteDetalle } from '../logistica/consultas'
import { FormCliente } from './FormCliente'
import { cuerpoEdicion, estaDeBaja, valoresDeFicha } from './formCliente'
import { GestionBaja } from './GestionBaja'
import { PreciosCliente } from './PreciosCliente'

/** Ficha editable de un cliente: datos, etiquetas, coordenadas, precios y baja. */
export function FichaCliente({ id, nombre, onCerrar }: { id: string; nombre: string; onCerrar: () => void }) {
  const detalle = useClienteDetalle(id)
  const editar = useEditarCliente(id)
  const admin = useEsAdmin()
  const ficha = detalle.data
  const deBaja = estaDeBaja(ficha)

  return (
    <Modal titulo={`Ficha de ${ficha?.nombre ?? nombre}`} onCerrar={onCerrar} anchoMax="max-w-3xl">
      <CabeceraModal titulo={ficha?.nombre ?? nombre} onCerrar={onCerrar} />
      <div className="min-h-0 flex-1 overflow-y-auto px-5 py-4">
        {detalle.isPending ? (
          <Cargando mensaje="Cargando la ficha del cliente" />
        ) : detalle.isError ? (
          <EstadoError error={detalle.error} onReintentar={() => void detalle.refetch()} />
        ) : ficha ? (
          <div className="flex flex-col gap-4">
            <div className="flex flex-wrap items-center gap-2">
              {deBaja ? <Insignia tono="atencion">De baja</Insignia> : <Insignia tono="positivo">Activo</Insignia>}
              {editar.isSuccess ? <span role="status" className="text-sm text-positivo-tinta">Cambios guardados.</span> : null}
            </div>
            <FormCliente
              // Al guardar, la ficha nueva rehace el formulario con lo que devuelve el backend.
              key={JSON.stringify(valoresDeFicha(ficha))}
              inicial={valoresDeFicha(ficha)}
              rotuloGuardar="Guardar cambios"
              guardando={editar.isPending}
              error={editar.error}
              onGuardar={(v) => {
                const cuerpo = cuerpoEdicion(valoresDeFicha(ficha), v)
                if (Object.keys(cuerpo).length > 0) editar.mutate(cuerpo)
              }}
            />
            <PreciosCliente contactId={id} admin={admin} />
            <GestionBaja contactId={id} deBaja={deBaja} bajaHasta={ficha.bajaHasta} />
          </div>
        ) : null}
      </div>
    </Modal>
  )
}
